export default "__VITE_ASSET__0da7565b__"